import * as _ from 'lodash-es';
import { Injectable } from '@angular/core';

@Injectable()
export class ServiceResponseProcessor {
    
    processError(errorResponse, error_types) {
        // Prefer the exception field over the type field
        var error_code = _.get(errorResponse, 'exception',
            _.get(errorResponse, 'type', '')
        );
        // Map the exception/type string to the related message
        // or use the error code if no message is available
        return ' ' + _.get(error_types, error_code, error_code);
    }

    process(response, errors, error_types) {
        if (!errors) {
            errors = [];
        }
        for (var field_name in response) {
            if (Array.isArray(response[field_name])) {
                for (var i = 0; i < response[field_name].length; i++) {
                    if (errors[field_name] === undefined) {
                        errors[field_name] = '';
                    }
                    errors[field_name] += this.processError(response[field_name][i], error_types);
                }
            } else {
                errors[field_name] = this.processError(response[field_name], error_types);
            }
        }
        return errors;
    }
}